import { fork } from 'redux-saga/effects';

import libs from 'store/libs/saga';
import features from 'store/features/saga';

export default function* rootSaga() {
  yield fork(libs);
  yield fork(features);
}



// WEBPACK FOOTER //
// ./src/store/saga.js